import { render, staticRenderFns } from "./import-itens-produto-review.vue?vue&type=template&id=79e501ad&scoped=true&"
import script from "./import-itens-produto-review.vue?vue&type=script&lang=js&"
export * from "./import-itens-produto-review.vue?vue&type=script&lang=js&"
import style0 from "./import-itens-produto-review.vue?vue&type=style&index=0&id=79e501ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e501ad",
  null
  
)

export default component.exports